import BSCLOGO from '@/assets/imgs/chain/bnb-logo.png'
import FSCLOGO from '@/assets/imgs/chain/fsc-logo.png'
import ETHLOGO from '@/assets/imgs/chain/eth-logo.png'
import POLYGONLOGO from '@/assets/imgs/chain/polygon-logo.png'
import TRONLOGO from '@/assets/imgs/chain/tron-logo.png'
export const buildTxUrl = (chain, trx_id) => {
  return chain.chainId == 95500? `${chain.explorer}/#/transaction/${trx_id.substr(2).toLowerCase()}`: `${chain.explorer}/tx/${trx_id}`
}
export const buildAddrUrl = (chain, addr) => {
  return chain.chainId == 95500? `${chain.explorer}/#/address/${addr}`: `${chain.explorer}/address/${addr}`
}
const exchangeContract = "0xda98Aa8a2624702AA79174D685baDdA036D041D0"
const exchangeAccount = "0x3973bC3391Cc77C30D3303A023c1B58fCBb9e7e2" // TFCzAQvnYvKup52Ft2Tav6Q1JuX8QbAeBA

export const Chains = {
  bsc: {
    chainId: 56,
    explorer: 'https://bscscan.com',
    logo: BSCLOGO,
    contract: '0x519a5bD234e88ccf41C87d9730122E5C82F2214E',
    usdt: '0x55d398326f99059ff775485246999027b3197955',
    ausdt: '0xa9251ca9DE909CB71783723713B21E4233fbf1B1',
    usdtDecimals: 18,
    name: 'BNB Chain',
    coin: 'BNB',
    rpc: 'https://1rpc.io/bnb',
    rpcs: [
      'https://1rpc.io/bnb',
      'https://bsc.publicnode.com',
      'https://bsc-dataseed4.ninicoin.io',
      'https://rpc.hieswap.com',
      'https://bsc.drpc.org',
    ],
    gasFee: 0.15, // usdt
    feeRate: 0.3, // 0.3%
    gasPrice: 'floating',
    gasPriceFloor: 0.10, // follow BSC recommended minimum (gwei)
    gasPriceBump: 1.10, // modest bump to improve inclusion without overpaying
    gasPriceRetryFloor: 0.30, // emergency retry floor when node rejects low gas as underpriced
    gasFeeForNaive: 0.00033, // gas used 110000 * gasPrice 3000000000
    exchangeAccount,
    exchangeContract,
  },
  fsc: {
    chainId: 201022,
    explorer: 'https://fonscan.io',
    logo: FSCLOGO,
    contract: '0x055c89F69Cd06c02388a3B12cA385439De847D7B',
    usdt: '0x9a9eD7440a3850c4D7240c9FcA8B7C96802615f0',
    usdtDecimals: 18,
    name: 'FON Chain',
    coin: 'FON',
    nativeName: 'FON',
    nativeDecimals: 18,
    rpc: 'https://fsc-dataseed2.fonscan.io',
    rpcs: [
      'https://fsc-dataseed1.fonscan.io',
      'https://fsc-dataseed2.fonscan.io',
      'https://fsc-dataseed3.fonscan.io',
      'https://fsc-dataseed4.fonscan.io',
      'https://rpc.hieswap.com',
    ],
    gasFee: 0, // usdt
    feeRate: 0, // 0.3%
    withdraw: '0x8971A707c958e1EaE4147FF0318117049f50c6d2',
    gasPrice: 200,
    gasPriceFloor: 180,
    gasPriceRetryFloor: 200,
    gasPriceBump: 1.05,
    gasFeeForNaive: 0.0055,
    exchangeAccount,
    exchangeContract,
  },
  eth: {
    chainId: 1,
    explorer: 'https://etherscan.io',
    logo: ETHLOGO,
    contract: '0xAb2A5E0D11906AC1Ca2b3dEa904Cb3de306E0F57',
    usdt: '0xdac17f958d2ee523a2206206994597c13d831ec7',
    usdtDecimals: 6,
    name: 'Ethereum',
    coin: 'ETH',
    rpc: 'https://eth.drpc.org',
    rpcs: [
      'https://eth.drpc.org',
      'https://ethereum.publicnode.com',
      'https://1rpc.io/eth',
    ],
    gasFee: 'floating', // 浮动gas费用
    nativePrice: '1700',
    feeRate: 0.3, // 0.4%
    gasPrice: 'floating',
    gasPriceBump: 1.10,
    exchangeAccount,
    exchangeContract,
  },
  polygon: {
    chainId: 137,
    explorer: 'https://polygonscan.com',
    logo: POLYGONLOGO,
    contract: '0xb024bb315A1a04b9663Ba7d67A5351D7B2943A57',
    usdt: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
    usdtDecimals: 6,
    name: 'Polygon',
    coin: 'POL',
    rpc: 'https://polygon.drpc.org',
    rpcs: [
      'https://polygon.drpc.org',
      'https://1rpc.io/matic',
      'https://polygon-bor-rpc.publicnode.com',
    ],
    gasFee: 'floating', // 浮动gas费用
    nativePrice: '1.5',
    feeRate: 0.3, // 0.3%
    gasPrice: 'floating',
    gasPriceBump: 1.10,
    exchangeAccount,
    exchangeContract,
  },
  // okc: {
  //   chainId: 66,
  //   explorer: 'https://www.oklink.com/en/okc',
  //   logo: OKCLOGO,
  //   contract: '0xF17bA42F4d74528551FD590b71F252A124dE80C2',
  //   usdt: '0x382bb369d343125bfb2117af9c149795c6c65c50',
  //   usdtDecimals: 18,
  //   name: 'OKX Chain',
  //   coin: 'OKT',
  //   rpc: 'https://exchainrpc.okex.org',
  //   gasFee: 4, // usdt
  //   feeRate: 0.3, // 0.3%
  //   gasPrice: 1000,
  //   gasFeeForNaive: 0.11,
  //   exchangeAccount,
  //   exchangeContract: '0x0a903c103E89030483AAA0B16253F378e9E54c00',
  // },
  // heco: {
  //   chainId: 128,
  //   explorer: 'https://www.hecoinfo.com/en-us',
  //   logo: HECOLOGO,
  //   contract: '0x0540aFd2D9cF059dbd66c4b416aA18609dC6a09A',
  //   usdt: '0xa71edc38d189767582c38a3145b5873052c3e47a',
  //   usdtDecimals: 18,
  //   name: 'HECO',
  //   coin: 'HT',
  //   rpc: 'https://http-mainnet.hecochain.com',
  //   gasFee: 0.15, // usdt
  //   feeRate: 0.3, // 0.3%
  //   gasPrice: 3,
  //   gasFeeForNaive: 0.00033,
  //   exchangeAccount,
  //   exchangeContract,
  // },
  tron: {
    chainId: 95500,
    explorer: 'https://tronscan.org',
    logo: TRONLOGO,
    contract: '0xb822dfc2918bdffb5bdf9c0dac7f91e2c4db7d26', // TSkq7SwpgNt7jHtRtCZVVAfVMnEhzezMRL'
    usdt: '0xa614f803b6fd780986a42c78ec9c7f77e6ded13c', // TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t
    usdtDecimals: 6,
    name: 'TRON',
    coin: 'TRX',
    rpc: 'https://tron.drpc.org',
    rpcs: [
      'https://tron.drpc.org',
      'https://api.trongrid.io/jsonrpc',
      'https://tron.api.pocket.network',
    ],
    gasFee: 6, // usdt
    feeRate: 0.5, // 0.5%
    gasFeeForNaive: 38,
    exchangeAccount,
    exchangeContract: "0xeddce7d6ad167d93b95d43dd04b3aaa19746eb42", // TXeunKBfJmKVhpbzB6r2xY6CvuwkeHCWG1
  },
}

const ChainNames = Object.keys(Chains)

export const ChainContracts = ChainNames.map(chain => Chains[chain].usdt.toLowerCase())

export const ChainFromId = {
  [1]: 'eth',
  [56]: 'bsc',
  // [66]: 'okc',
  // [128]: 'heco',
  [137]: 'polygon',
  [201022]: 'fsc',
  [95500]: 'tron',
}

/** 各链钱包行主题色（图标渐变 + 地址字色），与链 badge 一致便于区分从/到 */
const CHAIN_WALLET_BRAND = {
  56: {
    a: '#fce566',
    b: '#f0b90b',
    c: '#c99400',
    glow: 'rgba(240, 185, 11, 0.32)',
    addr: '#9a7209',
    tagBg: 'rgba(240, 185, 11, 0.14)',
    tagBorder: 'rgba(240, 185, 11, 0.28)',
  },
  201022: {
    a: '#c4b5fd',
    b: '#7c5cfc',
    c: '#5b37d6',
    glow: 'rgba(124, 92, 252, 0.32)',
    addr: '#5b37d6',
    tagBg: 'rgba(124, 92, 252, 0.12)',
    tagBorder: 'rgba(124, 92, 252, 0.28)',
  },
  1: {
    a: '#a7b8f5',
    b: '#627eea',
    c: '#4c63d2',
    glow: 'rgba(98, 126, 234, 0.32)',
    addr: '#4c63d2',
    tagBg: 'rgba(98, 126, 234, 0.12)',
    tagBorder: 'rgba(98, 126, 234, 0.26)',
  },
  137: {
    a: '#c4a0f8',
    b: '#8247e5',
    c: '#6b2fc9',
    glow: 'rgba(130, 71, 229, 0.32)',
    addr: '#6b2fc9',
    tagBg: 'rgba(130, 71, 229, 0.12)',
    tagBorder: 'rgba(130, 71, 229, 0.26)',
  },
  95500: {
    a: '#ff8a94',
    b: '#eb0029',
    c: '#c40020',
    glow: 'rgba(235, 0, 41, 0.28)',
    addr: '#c40020',
    tagBg: 'rgba(235, 0, 41, 0.1)',
    tagBorder: 'rgba(235, 0, 41, 0.22)',
  },
}

const DEFAULT_WALLET_BRAND = {
  a: '#f5d56a',
  b: '#f0b90b',
  c: '#c99400',
  glow: 'rgba(240, 185, 11, 0.28)',
  addr: '#8a6914',
  tagBg: 'rgba(240, 185, 11, 0.14)',
  tagBorder: 'rgba(240, 185, 11, 0.28)',
}

export function getChainWalletStyle(chainId) {
  const b = CHAIN_WALLET_BRAND[Number(chainId)] || DEFAULT_WALLET_BRAND
  return {
    '--hs-wallet-grad-a': b.a,
    '--hs-wallet-grad-b': b.b,
    '--hs-wallet-grad-c': b.c,
    '--hs-wallet-clasp': '#ffffff',
    '--hs-wallet-glow': b.glow,
    '--hs-wallet-addr': b.addr,
    '--hs-wallet-logo-bg': b.tagBg,
    '--hs-wallet-logo-border': b.tagBorder,
  }
}

export function getChainTagStyle(chainId) {
  const b = CHAIN_WALLET_BRAND[Number(chainId)] || DEFAULT_WALLET_BRAND
  return {
    color: b.addr,
    background: b.tagBg,
    borderColor: b.tagBorder,
  }
}

export function getChainFromId(chainId){
  return Chains[ChainFromId[chainId]]
}

/** 浏览器直连会触发 CORS 预检失败的 RPC 域名（服务端/脚本仍可用） */
const BROWSER_RPC_DENY_HOSTS = [
  'rpc.nodeflare.app',
]

/** 高频并行读链时易 429 的域名，仅保留在顺序 failover 末尾 */
const BROWSER_RPC_PARALLEL_DENY_HOSTS = [
  'drpc.org',
]

function isBrowserRpcDenied(url) {
  const u = String(url || '').toLowerCase()
  return BROWSER_RPC_DENY_HOSTS.some((host) => u.includes(host))
}

function isBrowserParallelRpcDenied(url) {
  const u = String(url || '').toLowerCase()
  return BROWSER_RPC_PARALLEL_DENY_HOSTS.some((host) => u.includes(host))
}

/** 链配置的 RPC 列表；有 `rpcs` 时用数组，否则回退到单个 `rpc` */
export function getChainRpcUrls(chainConf) {
  if (!chainConf) return []
  let urls = []
  if (Array.isArray(chainConf.rpcs) && chainConf.rpcs.length) {
    urls = chainConf.rpcs.map((u) => String(u).trim()).filter(Boolean)
  } else {
    const single = chainConf.rpc ? String(chainConf.rpc).trim() : ''
    urls = single ? [single] : []
  }
  if (typeof window !== 'undefined') {
    const filtered = urls.filter((u) => !isBrowserRpcDenied(u))
    return filtered.length ? filtered : urls
  }
  return urls
}

/** 浏览器并行读链用 RPC（排除 CORS/429 敏感节点） */
export function getChainRpcUrlsForParallelRead(chainConf) {
  const urls = getChainRpcUrls(chainConf)
  if (typeof window === 'undefined') return urls
  const filtered = urls.filter((u) => !isBrowserParallelRpcDenied(u))
  return filtered.length ? filtered : urls
}

/** FON 等自定义链：MetaMask 若曾用错误 symbol（如 ETH）添加，仅 switch 不会修正，须先 add 覆盖 */
export function chainMustRegisterBeforeSwitch(chainId) {
  const id = Number(chainId)
  return id === 201022
}

/** EIP-3081 `wallet_addEthereumChain` 参数；TRON 等非 EVM 返回 null */
export function buildWalletAddEthereumChainParams(chainId) {
  const c = getChainFromId(chainId)
  if (!c || c.chainId == null) return null
  const id = Number(c.chainId)
  if (id === 95500) return null
  const hexId = '0x' + id.toString(16)
  const sym = String(c.coin || 'ETH').trim().slice(0, 11) || 'ETH'
  const nativeName = String(c.nativeName || c.coin || sym).trim().slice(0, 32) || sym
  const rpcUrls = getChainRpcUrls(c)
  if (!rpcUrls.length) return null
  return {
    chainId: hexId,
    chainName: String(c.name || `Chain ${id}`).slice(0, 64),
    nativeCurrency: {
      name: nativeName,
      symbol: sym,
      decimals: Number(c.nativeDecimals ?? 18),
    },
    rpcUrls,
    blockExplorerUrls: c.explorer ? [String(c.explorer)] : [],
  }
}

/** 切链前写入正确网络参数（修复 MetaMask 里 FON 显示成 ETH 的问题） */
export async function registerWalletNetworkIfNeeded(provider, chainId) {
  if (!provider?.request || !chainMustRegisterBeforeSwitch(chainId)) return
  const params = buildWalletAddEthereumChainParams(chainId)
  if (!params) return
  try {
    await provider.request({ method: 'wallet_addEthereumChain', params: [params] })
  } catch (e) {
    if (e?.code === 4001) throw e
    const msg = String(e?.message || e || '').toLowerCase()
    const benign =
      msg.includes('already') ||
      msg.includes('duplicate') ||
      msg.includes('same network')
    if (!benign) {
      console.warn('[hieswap] wallet_addEthereumChain', Number(chainId), e?.code || e?.message || e)
    }
  }
}

/** 兑换/进度/选链等 UI 用固定简称，避免全称在窄位被裁切 */
export function chainUiTicker(chain) {
  if (!chain || chain.chainId == null) return '--'
  const id = Number(chain.chainId)
  if (id === 56) return 'BSC'
  if (id === 201022) return 'FSC'
  if (id === 1) return 'ETH'
  if (id === 137) return 'POL'
  if (id === 95500) return 'TRON'
  const n = String(chain.name || '').toLowerCase()
  if (n.includes('bnb') || n.includes('bsc')) return 'BSC'
  if (n.includes('fon') || n.includes('fsc')) return 'FSC'
  if (n.includes('ethereum') || n === 'eth') return 'ETH'
  if (n.includes('polygon') || n.includes('matic')) return 'POL'
  if (n.includes('tron')) return 'TRON'
  const coin = String(chain.coin || '').toUpperCase()
  if (coin && coin.length <= 5) return coin
  if (coin) return coin.slice(0, 4)
  return '--'
}

/**
 * 跨链手续费率（%）：
 * - 从 FSC 发起：固定 0.5%
 * - 其余：看目标链 feeRate（FSC 目标 0%、TRON 目标 0.5%、BNB/ETH/Polygon 0.3%）
 */
export function getBridgeFeeRate(fromChain, toChain) {
  const fromId = Number(fromChain?.chainId)
  if (fromId === 201022) return 0.5
  return Number(toChain?.feeRate ?? 0)
}

export const AmountOpt = {
  min: 30, // 最小30U
  max: 100000, // 最大 10W U
  maxFee: 1000, // 最大手续费 1000U
}